module.exports = __webpack_public_path__ + "static/media/boomer-group.42e4261d.png";